import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Typography,
} from "@common-ui/ui";
import BoltIcon from "@mui/icons-material/Bolt";
import { QuickActionList } from "../../components/List/QuickActionList";

export const QuickActions = (props) => {
  return (
    <Card variant="outlined" style={{ height: "100%" }}>
      <CardHeader
        sx={{ pb: 0 }}
        avatar={
          <Avatar aria-label="actions" sx={{ width: 56, height: 56 }}>
            <BoltIcon />
          </Avatar>
        }
        title={<Typography variant="h4">Quick Actions</Typography>}
      />
      <CardContent>
        <QuickActionList {...props} />
      </CardContent>
    </Card>
  );
};
